<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12">
          <v-toolbar dark color="#F2341B">
            <v-toolbar-title>Sign In</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-alert :value="!!error" type="error" dismissible @input="error = ''">
              {{ error }}
            </v-alert>
            <v-form @submit.prevent="handleSignIn">
              <v-text-field
                v-model="username"
                label="Username"
                prepend-icon="person"
                required
              ></v-text-field>
              <v-text-field
                v-model="password"
                label="Password"
                prepend-icon="lock"
                :type="showPassword ? 'text' : 'password'"
                :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                @click:append="showPassword = !showPassword"
                required
              ></v-text-field>

              <v-text-field
                v-if="newPasswordRequired"
                v-model="newPassword"
                label="New Password"
                prepend-icon="lock_outline"
                type="password"
                required
              ></v-text-field>

              <v-btn
                type="submit"
                color="#F2341B"
                dark
                block
                :loading="loading"
              >
                {{ newPasswordRequired ? 'Set New Password' : 'Sign In' }}
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { Auth } from '@aws-amplify/auth';

export default {
  name: 'Login',
  data: function () {
    return {
      username: '',
      password: '',
      newPassword: '',
      error: '',
      loading: false,
      showPassword: false,
      newPasswordRequired: false,
      cognitoUser: null,
    };
  },
  methods: {
    handleSignIn: function () {
      var self = this;
      self.error = '';
      self.loading = true;

      if (self.newPasswordRequired && self.cognitoUser) {
        Auth.completeNewPassword(self.cognitoUser, self.newPassword)
          .then(function () {
            self.$router.push(self.$route.query.redirect || '/');
          })
          .catch(function (e) {
            self.error = e.message || 'Failed to set new password';
            self.loading = false;
          });
        return;
      }

      Auth.signIn(self.username, self.password)
        .then(function (user) {
          if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
            self.cognitoUser = user;
            self.newPasswordRequired = true;
            self.loading = false;
            return;
          }
          self.$router.push(self.$route.query.redirect || '/');
        })
        .catch(function (e) {
          self.error = e.message || 'Sign in failed';
          self.loading = false;
        });
    },
  },
};
</script>
